import { ApplicantType } from "shared/types";

export const getApplicantRole = (role?: ApplicantType | null) => {
  if (role === ApplicantType.Occupant) return "Occupant";

  if (role === ApplicantType.CoSigner) return "Guarantor";

  if (role === ApplicantType.Applicant) return "Applicant";

  return "-";
};
